import React from "react";
import ReusableDropdown, { unifiedControlStyle } from "../../../components/ReusableDropdown";

// Search / department / status / company filter controls
const EmployeeFilters = ({
  styles,
  text,
  language,
  theme,
  screenSize,
  searchTerm,
  setSearchTerm,
  filterDepartment,
  setFilterDepartment,
  filterStatusSearch,
  setFilterStatusSearch,
  setFilterStatus,
  filterCompanySearch,
  setFilterCompanySearch,
  setFilterCompany,
  companies,
}) => (
  <div style={styles.filterContainer}>
    {/* Search Input */}
    <div style={styles.filterGroup}>
      <label style={styles.filterLabel}>
        {text[language].searchEmployee}
      </label>
      <input
        type="text"
        placeholder={text[language].searchNameIdEmail}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={styles.filterInput}
      />
    </div>

    {/* Department Filter */}
    <div style={styles.filterGroup}>
      <label style={styles.filterLabel}>
        {text[language].department}
      </label>

      <input
        type="text"
        placeholder={text[language].searchDepartment}
        value={filterDepartment}
        onChange={(e) => setFilterDepartment(e.target.value)}
        style={styles.filterInput}
      />
    </div>

    {/* Status Filter */}
    <div style={styles.filterGroup}>
      <label style={styles.filterLabel}>{text[language].Status}</label>
      <div style={{ position: 'relative' }}>
        <ReusableDropdown
          items={[
            { key: '', label: text[language].allStatuses },
            { key: 'Active', label: text[language].statusActive },
            { key: 'OnLeave', label: text[language].statusOnLeave },
            { key: 'Inactive', label: text[language].statusInactive },
          ]}
          value={filterStatusSearch}
          onChange={(val) => setFilterStatusSearch(val)}
          onSelect={(item) => {
            setFilterStatus(item.key);
            setFilterStatusSearch(item.label);
          }}
          placeholder={text[language].selectStatus || text[language].Status}
          getItemKey={(it) => it.key}
          getItemLabel={(it) => it.label}
          theme={theme}
          language={language}
          inputStyle={unifiedControlStyle(theme, language === 'ar')}
          maxItems={6}
        />
      </div>
    </div>
    {screenSize !== "xs" && (
      <div style={styles.filterGroup}>
        <label style={styles.filterLabel}>{text[language].company}</label>
        <div style={{ position: 'relative' }}>
          <ReusableDropdown
            items={[{ key: '', label: text[language].allCompanies }, ...(companies || []).map(c => ({ key: c, label: c }))]}
            value={filterCompanySearch}
            onChange={(val) => setFilterCompanySearch(val)}
            onSelect={(item) => {
              setFilterCompany(item.key || '');
              setFilterCompanySearch(item.label || '');
            }}
            placeholder={text[language].allCompanies}
            getItemKey={(it) => it.key}
            getItemLabel={(it) => it.label}
            theme={theme}
            language={language}
            inputStyle={unifiedControlStyle(theme, language === 'ar')}
            maxItems={8}
          />
        </div>
      </div>
    )}
  </div>
);

export default EmployeeFilters;
